import {List, ListItem} from '@kit';

import React, {useId, useMemo} from 'react';

import {useGallery, useGalleryImages} from './gallery-context';
import {Image} from '../../generated/types';
import {coverSize, imageUrl} from '../utils';

import css from './gallery.module.css';

// размер миниатюры — как у .thumbnail img в gallery.module.css
const THUMB_WIDTH = 194;
const THUMB_HEIGHT = 150;

type Props = {
	images: Image[];
	title?: string;
	startIndex?: number;
};

export const Gallery: React.FC<Props> = ({images, title, startIndex = 0}) => {
	const galleryImages = useMemo(
		() =>
			images.map((img) => ({
				id: img.id,
				url: imageUrl(img.path),
				preview: imageUrl(img.path, coverSize(img.width, img.height, THUMB_WIDTH, THUMB_HEIGHT)),
				description: img.description || '',
				credits: img.credits,
				width: img.width,
				height: img.height,
			})),
		[images],
	);

	useGalleryImages(galleryImages);
	const openImage = useGallery();
	const headingId = useId();

	const displayImages = startIndex > 0 ? galleryImages.slice(startIndex) : galleryImages;

	if (!displayImages.length) return null;

	return (
		// галерея — дополнение к статье, поэтому это её footer
		<footer>
			<section aria-labelledby={title ? headingId : undefined} aria-label={title ? undefined : 'Галерея'}>
				{title && <h2 id={headingId}>{title}</h2>}
				<List horizontal navigationMode="items" className={css.thumbnails}>
					{displayImages.map((image, index) => (
						<ListItem
							key={image.id}
							value={image.id}
							href={image.url}
							onAction={(_, __, e) => {
								e.preventDefault();
								openImage(image.id);
							}}
							buttonClassName={css.thumbnailButton}
							title={image.description || `Иллюстрация ${index + 1}`}
						>
							<img
								src={image.preview}
								alt={image.description || `Иллюстрация ${index + 1}`}
								width={THUMB_WIDTH}
								height={THUMB_HEIGHT}
								loading="lazy"
								decoding="async"
							/>
						</ListItem>
					))}
				</List>
			</section>
		</footer>
	);
};
